import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/jobs/pages/job-details/src/components/job-metadata/assets/og-xing-logo.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')